export const clients = [
    {
      "id": "bd4980cc-2fb4-495b-8ea2-09679aed78e1",
      "name": "FH.BY",
      "description": "Сеть магазинов модной одежды с более чем 50 торговыми точками по всей стране.",
      "industry": "retail",
      "result": "Увеличение продаж на 35% и оптимизация управления запасами.",
      "status": "active",
      "created_at": "2025-03-31 08:18:58.609205+00",
      "updated_at": "2025-03-31 08:18:58.609205+00",
      "logo_url": "https://fh.by/_next/image?url=%2Fimages%2Ffhby.webp&w=96&q=75"
    },
    {
      "id": "32f18408-ad75-4eab-9dae-48d94d35de39",
      "name": "Mircli",
      "description": "Онлайн-маркетплейс с широким ассортиментом товаров для дома и быта.",
      "industry": "ecommerce",
      "result": "Улучшение пользовательского опыта и рост конверсии на 28%.",
      "status": "active",
      "created_at": "2025-04-01 06:45:10.960598+00",
      "updated_at": "2025-04-01 06:45:10.960598+00",
      "logo_url": "https://habrastorage.org/getpro/moikrug/uploads/company/100/007/825/3/logo/medium_83b5009e040969ee7b60362ad7426573.jpeg"
    },
    {
      "id": "5415308a-6343-43cb-8570-87a2eee7680f",
      "name": "HollyShop",
      "description": "Интернет-магазин косметики и парфюмерии премиум-класса.",
      "industry": "ecommerce",
      "result": "Внедрение омниканальной стратегии и увеличение среднего чека на 40%.",
      "status": "draft",
      "created_at": "2025-04-01 06:46:08.522337+00",
      "updated_at": "2025-04-01 06:46:08.522337+00",
      "logo_url": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFUULaCUaYwV7rpgXxkyLXaj5ErZmNpbEXGQ&s"
    },
    {
      "id": "6ad67b54-5196-40ff-b7ef-107cb82e0e2a",
      "name": "Savage",
      "description": "Российский бренд женской одежды с собственной сетью магазинов.",
      "industry": "retail",
      "result": "Автоматизация процессов и снижение операционных расходов на 25%.",
      "status": "active",
      "created_at": "2025-04-01 06:47:15.738832+00",
      "updated_at": "2025-04-01 06:47:15.738832+00",
      "logo_url": "https://toplogos.ru/images/logo-savage.png"
    },
    {
      "id": "5a68bcb0-487a-4f38-9bbe-3dbafe223ea0",
      "name": "Mothercare KZ",
      "description": "Международная сеть магазинов товаров для беременных женщин и детей.",
      "industry": "retail",
      "result": "Интеграция онлайн и офлайн каналов продаж и рост клиентской базы на 30%.",
      "status": "active",
      "created_at": "2025-04-01 06:47:53.707491+00",
      "updated_at": "2025-04-01 06:47:53.707491+00",
      "logo_url": "https://logowik.com/content/uploads/images/mothercare1799.jpg"
    }
  ];


